import { render, staticRenderFns } from "./soucelisttwo.vue?vue&type=template&id=79c2a531&scoped=true"
import script from "./soucelisttwo.vue?vue&type=script&lang=js"
export * from "./soucelisttwo.vue?vue&type=script&lang=js"
import style0 from "./soucelisttwo.vue?vue&type=style&index=0&id=79c2a531&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c2a531",
  null
  
)

export default component.exports